import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/utils2";
import { LOGO } from "@/lib/constants";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Admin!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-navy px-6">
      <form onSubmit={submit} data-testid="admin-login-form" className="bg-white rounded-3xl p-8 sm:p-10 shadow-2xl w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO} alt="logo" className="h-16 w-16 mx-auto object-contain" />
          <h1 className="font-head font-extrabold text-2xl text-navy mt-4">Admin Panel</h1>
          <p className="text-sm text-slate-500">B.R.Smart Kidz / Academy</p>
        </div>
        <div className="space-y-4">
          <Input data-testid="admin-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Input data-testid="admin-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <Button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-brandred hover:bg-brandred/90 text-white rounded-full h-12 font-semibold">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="mr-1.5 h-4 w-4" /> Login</>}
          </Button>
        </div>
      </form>
    </div>
  );
}
